import CannedResponses from "../../views/cannedResponses/Index.vue";

const CannedResponsesRoute = [
  {
    path: "/canned-responses",
    name: "CannedResponses",
    component: CannedResponses,
  },
];

export default CannedResponsesRoute;
